module.exports = __webpack_public_path__ + "static/media/malaysia.c9665d34.svg";